import * as utils from '../utils';
import NavBarMenuContentItem from './NavBarMenuContentItem';

const { Root, Badge, Label } = NavBarMenuContentItem;

type Option = Replace<utils.NavOption, Partial<Pick<utils.NavOption, 'panel' | 'skin'>>>;

export type NavBarItemWrapperProps = {
  option: Option;
  onSelect: (option: Option) => () => void;
};

const NavBarMenuContentItemWrapper = ({ option, onSelect }: NavBarItemWrapperProps) => {
  const { id, key, to, label, isDisabled, skin, panel } = option;
  return (
    <li key={id} onClick={onSelect(option)}>
      <Root to={to} isDisabled={isDisabled} blockNavigation={utils.isNavigationBlocked(option)} data-testid={utils.PRODUCT_MENU_TEST_IDS[key]}>
        {skin && panel && <Badge skin={skin}>{panel}</Badge>}
        <Label>{label}</Label>
      </Root>
    </li>
  );
};

export default NavBarMenuContentItemWrapper;
